module.exports = __webpack_public_path__ + "img/holiday-on-ice.a34bc451.jpg";